<!-- components/Pagination.vue -->
<template>
  <nav aria-label="Search results pagination">
    <ul class="pagination">
      <li class="page-item" :class="{ disabled: currentPage === 0 }">
        <a 
          class="page-link" 
          href="#" 
          @click.prevent="goToPage(currentPage - 1)"
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      
      <li 
        v-for="page in visiblePages" 
        :key="page"
        class="page-item" 
        :class="{ active: page === currentPage }"
      >
        <a 
          class="page-link" 
          href="#" 
          @click.prevent="goToPage(page)"
        >
          {{ page + 1 }}
        </a>
      </li>
      
      <li class="page-item" :class="{ disabled: currentPage >= totalPages - 1 }">
        <a 
          class="page-link" 
          href="#" 
          @click.prevent="goToPage(currentPage + 1)"
          aria-label="Next"
        >
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    maxVisiblePages: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    visiblePages() {
      const pages = [];
      const start = Math.max(0, this.currentPage - Math.floor(this.maxVisiblePages / 2));
      const end = Math.min(this.totalPages, start + this.maxVisiblePages);
      
      for (let i = start; i < end; i++) {
        pages.push(i);
      }
      
      return pages;
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 0 && page < this.totalPages && page !== this.currentPage) {
        this.$emit('page-change', page);
      }
    },
  },
};
</script>

<style scoped>
.pagination {
  justify-content: center;
}
</style>